import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import { Modal, Button, Form } from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert'


class EditProductItem extends React.Component {

	constructor(props, context) {
		super(props, context);
		this.handleClose = this.handleClose.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleShow = this.handleShow.bind(this);
		this.handleChangeMulti = this.handleChangeMulti.bind(this);

		this.state = {
		  styleCode:'',
		  isStyleCodeValid:true,//wait for at least 1 char entered
		  errMsg:'',
		  isEdited:false,
		  multiProducts:true,
		};
	}

	handleShow(){
		this.setState({
    		styleCode: '',
    	});
	}

	handleClose(){
		this.setState({
    		styleCode: '',
    		isStyleCodeValid:true,
    		errMsg:'',
    	});
		this.props.onClose();
	}

	handleChange(event) {

		let isScValid = true;
		let scErrMsg = "";

		if(this.state.multiProducts){
			if(event.target.value !== ''){
				let stylecodes = event.target.value.split('\n')
				let wrongScs = stylecodes.filter((itm)=>{return itm.length !== 15});
				isScValid = wrongScs.length === 0;
				if(!isScValid) scErrMsg = "Wrong error codes: " + wrongScs.join(", ");
			}
			//console.log(event.target.value);
		}else{
			isScValid = event.target.value.length === 15;
			scErrMsg = 'Style code must be 15 characters long. Current characters:' + event.target.value.length;
		}

    	this.setState({
    		isEdited:true,
    		styleCode: event.target.value,
    		isStyleCodeValid:isScValid,
    		errMsg:scErrMsg,
    	});
  	}

	handleSubmit(event) {

		if(this.state.isEdited ){ 
			if(this.state.isStyleCodeValid){
		    	this.setState({ show: false });		

		    	if(this.props.action === 'Add')	this.props.onProductAdded(this.state.styleCode);
		    	else this.props.onProductRemoved(this.state.styleCode);
			}
		}else{
			this.setState({
		    		isStyleCodeValid:false,
		    		errMsg:'Please enter STYLE-MATERIAL-CODE',
		    });
		}
    	event.preventDefault();
  	}

  	handleChangeMulti(evt) {
    	this.setState({ multiProducts: evt.target.checked });
  	}
  

	render(){
		return (

		<Modal show={this.props.shouldShow} onHide={this.handleClose} onShow={this.handleShow}>
          <Modal.Header closeButton>
            <Modal.Title> {this.props.action} product </Modal.Title>
          </Modal.Header>
          <Modal.Body>
        	<form onSubmit={this.handleSubmit}>
			<Form.Check checked={this.state.multiProducts}
          			onChange={this.handleChangeMulti} type="checkbox" label='List' /> 
			Style code{this.state.multiProducts?'s':''}<br/>
				<input type="text" value={this.state.styleCode}  
				style={{display:this.state.multiProducts?'none':'',width:'250px'}} 
				onChange={this.handleChange} placeholder="STYLE-MATERIAL-CODE"/>
				<textarea style={{display:this.state.multiProducts?'':'none',width:'250px'}} 
				onChange={this.handleChange} rows="15" placeholder="STYLE-MATERIAL-CODE per line"/>
          	</form>
			<Alert variant='danger' show={!this.state.isStyleCodeValid}>
	      		{this.state.errMsg}
			</Alert> 
		
          </Modal.Body>
          <Modal.Footer>           
            <Button variant="primary" onClick={this.handleSubmit}>
              {this.props.action} product
            </Button>
            
          </Modal.Footer>
        </Modal>
		);
	}
}

export default EditProductItem;